import { AxiosResponse } from 'axios';
import _, { Omit } from 'lodash';
import http from './http';
import { getAuthData } from './tokenData';
import { Bot, TradeOrder } from '@/dtos/bot';



export async function addBot(bot: Partial<Bot>): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.addBot',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: bot
      }
    })
    .then(res => res.data.data);
}

export async function updateBot(bot: Bot): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.updateBot',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: bot
      }
    })
    .then(res => res.data.data);
}

export async function removeBot(botId): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.removeBot',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: { id: botId }
      }
    })
    .then(res => res.data.data);
}


export async function botStartStop({ id, command }: { id: string, command: "start" | "stop" }): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.startStopBot',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: { id, enable: command == 'start' ? true : false }
      }
    })
    .then(res => res.data.data);
}


export async function botRestart({ id }: { id: string }): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.restartBot',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        body: { id }
      }
    })
    .then(res => res.data.data);
}

export async function addCustomData({ id, data }: { id: string, data }): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.addCustomData',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        body: data
      }
    })
    .then(res => res.data.data);
}

export async function getBalances({ id, label }: { id: string, label?: string }): Promise<{ currency, total, in_order, available }[]> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.getBalances',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        label,
      }
    })
    .then(res => res.data.data);
}

export async function getAccountInfo({ id, label }: { id: string, label?: string }): Promise<{account_id,email,nick_name,create_at}> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.getAccountInfo',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        label,
      }
    })
    .then(res => res.data.data);
}

export async function getOpenOrders({ id, label }: { id: string, label?: string }, page = 0): Promise<any> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.getOpenOrders',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        page: page,
        label,
      },
    })
    .then(res => res.data.data);
}
export async function getCompleteOrders({ id, label }: { id: string, label?: string }, page = 0): Promise<any> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.getCompleteOrders',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        page: page,
        label,
      },
    })
    .then(res => res.data.data);
}

export async function getTrades({ id, label }: { id: string, label?: string },filter: Partial<{limit,from_id,symbol}> = {}): Promise<TradeOrder[]> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.getTrades',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        body: filter,
        label,
      }
    })
    .then(res => res.data.data);
}

export async function cancelAllOrder({ id, label }: { id: string, label?: string }): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.cancelAllOrder',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        label,
      }
    })
    .then(res => res.data.data);
}

export async function cancelOrder({ id, label }: { id: string, label?: string }, orderId): Promise<void> {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.cancelOrder',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        label,
        body:{
          orderId
        }
      }
    })
    .then(res => res.data.data);
}


export async function placeOrder({ id, pair, label }: {id, pair, label }, { amount, price, side }) {
  const { project, token } = getAuthData()
  return http
    .callApi({
      resource: 'bot.placeOrder',
      headers: {
        authorization: token
      },
      data: {
        project: project,
        botId: id,
        label,
        body:{ amount, price, side }
      }
    })
    .then(res => res.data.data);
}

